import React from 'react';

// =============================================================================
// WiringNotes — layout-phase scaffolding.
//
// A small amber panel that hangs at the bottom of a mockup page to carry the
// "what still needs wiring" notes: intended schema, Express routes, cross-module
// joins, access rules, phasing. It keeps the design intent attached to the page
// so nothing is lost between the layout phase and the wiring phase.
//
// Delete these panels (and the <WiringNotes> imports) once a page is fully wired.
// =============================================================================
const WiringNotes = ({ notes = [], schema, routes }) => (
  <section className="rounded-xl border border-amber-200 dark:border-amber-500/30 bg-amber-50/70 dark:bg-amber-500/5 p-4">
    <h3 className="m-0 mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-amber-700 dark:text-amber-400">
      🔌 Wiring notes <span className="font-medium normal-case tracking-normal text-amber-600/70 dark:text-amber-400/70">(layout phase — remove once wired)</span>
    </h3>

    {notes.length > 0 && (
      <ul className="m-0 pl-5 list-disc space-y-1 text-xs text-slate-600 dark:text-slate-300">
        {notes.map((n, i) => <li key={i}>{n}</li>)}
      </ul>
    )}

    {(schema || routes) && (
      <details className="mt-3">
        <summary className="cursor-pointer text-xs font-semibold text-amber-700 dark:text-amber-400">
          Proposed schema &amp; routes
        </summary>
        {routes && (
          <pre className="mt-2 overflow-x-auto rounded-md bg-slate-900 text-slate-100 text-[11px] leading-relaxed p-3">{routes}</pre>
        )}
        {schema && (
          <pre className="mt-2 overflow-x-auto rounded-md bg-slate-900 text-slate-100 text-[11px] leading-relaxed p-3">{schema}</pre>
        )}
      </details>
    )}
  </section>
);

export default WiringNotes;
